"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParserDependencies = void 0;

var _dependenciesParseGenerated = require("./dependenciesParse.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var ParserDependencies = {
  parseDependencies: _dependenciesParseGenerated.parseDependencies,
  createParserClass: _factoriesAny.createParserClass
};
exports.ParserDependencies = ParserDependencies;